import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import InvoiceService from "./invoiceService";
import { getInvoiceDTO } from "../../dtos/invoice";


// Define initial state
const initialState = {
  invoiceDetails: [],
  invoiceId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",




  isInvoiceLoading: false,


 
  isInvoiceLoadingError: false,
};



// export const AddInvoice = createAsyncThunk(
//   "/api/pharmacy/invoice/add",
//   async (invoice: AddInvoiceDTO, thunkAPI) => {
//     try {
//       return await InvoiceService.AddInvoice(invoice);
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const getInvoiceData = createAsyncThunk(
  "invoice/getInvoiceData", // Action type prefix
  async (invoice: getInvoiceDTO,  thunkAPI) => {
    try {
      const response = await InvoiceService.getInvoice(invoice); // Call the function
      return response.data; 
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const editInvoice = createAsyncThunk(
//   "invoice/edit",
//   async (invoice: AddInvoiceDTO, thunkAPI) => {
//     try {
//       return await InvoiceService.editInvoice(invoice);
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
export const invoiceSlice = createSlice({
  name: "invoiceSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeInvoiceId: (state, action) => {
      state.invoiceId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.invoiceDetails = action.payload;
        state.message = "";
      })
      .addCase(getInvoiceData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeInvoiceId } = invoiceSlice.actions;
export default invoiceSlice.reducer;
